import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { LoadingScreen } from "Components";
import { newAuthService } from "Service/Axios";
import { getCareerHubJobsListUrl } from "Constant/api";
import { usePagination } from "Utils/hooks";
import { DEFAULT_PAGE_SIZE } from "Constant/constants";

export const SavedJobs = ({ show, toggle, toggleJobDetailsModal }) => {
  const jobsListRef = React.useRef(null);
  const loadingRowRef = React.useRef(null);

  const [totalJobs, setTotalJobs] = useState(0);
  const [jobsLoading, setJobsLoading] = useState(true);
  const [jobsList, setJobsList] = useState([]);

  const fetchJobsList = async () => {
    // setJobsLoading(true);
    const payload = {
      save: true,
      skip: currPage * DEFAULT_PAGE_SIZE,
      take: DEFAULT_PAGE_SIZE,
    };
    const response = await newAuthService(
      getCareerHubJobsListUrl,
      "POST",
      payload
    );
    setTotalJobs(response.data.total);
    setJobsList((prevList) => [...prevList, ...response.data.data]);
    setJobsLoading(false);
    return response.data.data;
  };

  const {
    paginationLoading,
    currPage,
    prevPage,
    lastList,
    fetchPaginatedData,
    fetchMoreDataOnScroll,
    goToNextPage,
    // resetPagination,
  } = usePagination(fetchJobsList, {
    containerRef: jobsListRef,
    loadingRowRef: loadingRowRef,
  });

  useEffect(() => {
    if (!paginationLoading && !lastList) {
      if (prevPage !== currPage) {
        fetchPaginatedData();
      } else if (
        jobsListRef.current &&
        jobsListRef.current.scrollHeight > 0 &&
        jobsListRef.current.clientHeight > 0 &&
        jobsListRef.current.scrollHeight <= jobsListRef.current.clientHeight
      ) {
        goToNextPage();
      }
    }
  }, [currPage, lastList, prevPage, paginationLoading]);

  return (
    <Modal
      show={show}
      onHide={toggle}
      className="modal text-start fade right modal-slider"
    >
      <Modal.Header closeButton className="rounded-0">
        <Modal.Title>Saved Jobs</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="text-slate-500"
        ref={jobsListRef}
        onScroll={fetchMoreDataOnScroll}
      >
        <div className="w-100 h-100 px-4 d-flex flex-column row-gap-3">
          <div className="d-flex align-items-center column-gap-2">
            <h3 className="mb-0 text-base font-bold text-slate-600">
              Total Jobs
            </h3>
            <small className="px-3 py-1 text-sm rounded-pill text-green-700 border border-green-400 bg-green-100">
              {totalJobs} Found
            </small>
          </div>
          <ul
            className="list-unstyled d-flex flex-column row-gap-3 h-100"
            // ref={jobsListRef}
            // onScroll={fetchMoreDataOnScroll}
          >
            {jobsLoading ? (
              <li className="w-100 h-100 d-flex jutify-content-center aligin-items-center job-loader">
                <LoadingScreen />
              </li>
            ) : jobsList && jobsList.length > 0 ? (
              <>
                {jobsList.map((job, index) => (
                  <li key={`${job.gid}-${index}`}>
                    <div className="p-2 d-flex align-items-center gap-3 rounded-lg border border-slate-200">
                      <div className="w-16 h-16 flex-auto d-flex justify-content-center align-items-center rounded border border-blue-200 bg-blue-200">
                        <img
                          src={job.image}
                          alt={job.name}
                          className="w-100 h-100 object-fit-cover"
                        />
                      </div>
                      <div className="d-flex flex-column row-gap-0">
                        <h4 className="mb-0 text-base font-bold text-slate-700">
                          {job.name}{" "}
                        </h4>
                        {job.organizationName && (
                          <span className="text-base text-slate-500">
                            {job.organizationName}
                          </span>
                        )}
                        <ul className="list-unstyled d-flex flex-wrap text-slate-500 list-fill-bullet">
                          <li className="text-xs px-3 position-relative">
                            <span>{job.type}</span>
                          </li>
                          {job.location && (
                            <li className="text-xs px-3 position-relative">
                              <span>On-Site</span>
                            </li>
                          )}
                        </ul>
                      </div>
                      <div className="d-flex flex-column align-items-end row-gap-2 ms-auto">
                        <button
                          type="button"
                          className="p-0 text-slate-500 border-0 bg-transparent"
                        >
                          <i className="bx bxs-bookmark"></i>
                        </button>
                        <button
                          type="button"
                          onClick={() => toggleJobDetailsModal(job.gid)}
                          className="btn btn-dark px-4 py-1"
                        >
                          Details
                        </button>
                      </div>
                    </div>
                  </li>
                ))}
                {!lastList && (
                  <li ref={loadingRowRef}>
                    <div className="p-2 d-flex justify-content-center align-items-center gap-3 rounded-lg border border-slate-200 job-loader">
                      <LoadingScreen />
                    </div>
                  </li>
                )}
              </>
            ) : (
              <li>
                <div className="p-2 d-flex align-items-center gap-3 rounded-lg border border-slate-200">
                  <p>No Jobs Found</p>
                </div>
              </li>
            )}
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
};
